import {
  FilterValue,
  MultiSelectFilter,
  StringArrayFilterValue,
} from "../../types/filter";
import { getSelectedFilterValue } from "../../utils/filter/filtervalue";
import { createFilterValueFromMultiSelectOption } from "../../utils/filter/selectfiltervalue";
import { AccordionMultiSelect } from "../FilterAccordion/AccordionMultiSelect";

interface InputSelectOptionProps {
  filter: MultiSelectFilter;
  filterValues: FilterValue[];
  openFilters: string[];
  onChange: (value: FilterValue) => void;
  onOpenChange: (isOpen: boolean) => void;
}

export const InputMultiSelectOption = ({
  filter,
  filterValues,
  openFilters,
  onChange,
  onOpenChange,
}: InputSelectOptionProps) => {
  const selected = getSelectedFilterValue(
    filter.id,
    filterValues,
    filter.defaultValue
  )! as StringArrayFilterValue;
  return (
    <AccordionMultiSelect
      filter={filter}
      selected={selected}
      onChange={(option, isSelected) => {
        const value = createFilterValueFromMultiSelectOption(
          filter.id,
          option,
          selected,
          isSelected
        );
        onChange(value);
      }}
      open={!!openFilters.find((filterId) => filterId === filter.id)}
      onOpenChange={onOpenChange}
    />
  );
};
